import React from "react";
import { cls } from "cls";
import { NavBarModel } from "../Models/PageCreatorPage";
import NavMenuItem from "./NavMenuItem";

const ImageNavBar = ({
  navItems,
  backgroundColor,
}: NavBarModel): JSX.Element => {
  return (
    <div
      id="image-nav-bar"
      className={cls("container", "mx-auto", "flex", "flex-col", "py-8")}
    >
      <h2
        className={`${cls(
          "mx-auto",
          "mb-8",
          "text-center",
        )} [text-wrap:balance]`}
        style={{ textDecoration: "none" }}
      >
        Shop the Best Deals of the Day
      </h2>
      <div
        className={cls(
          "flex",
          "flex-wrap",
          "justify-center",
          "gap-x-6",
          "gap-y-6",
          "mx-auto",
          "sm:gap-x-8",
          "max-w-5xl",
        )}
      >
        {navItems.map((navItem) => (
          <NavMenuItem
            imageUrl={navItem.imageUrl}
            title={navItem.title}
            backgroundColor={backgroundColor}
            url={navItem.url}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageNavBar;
